<script lang="ts">
    import { goto } from '$app/navigation'
	import { breadcrumbs_store } from '$lib/stores/breadcrumbs/breadcrumbs'

	let showBreadcrumbs = false

	$: showBreadcrumbs = $breadcrumbs_store.length > 0

</script>



{#if showBreadcrumbs}
	<div class="breadcrumbs">
		{#each $breadcrumbs_store as crumb, i}
			<span class="crumb">
				{#if i > 0}
					<span class="separator">/</span>
				{/if}
				
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<span 
					data-test-id="breadcrumbs-{crumb.label}"
					class="crumb-text" 
					class:active={i === $breadcrumbs_store.length - 1}
					on:click={() => goto(crumb.path)}>
					{crumb.label}
				</span>
			</span>
		{/each}
	</div>
{/if}

<style lang="postcss">
	.breadcrumbs {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		/* font-size: 1rem; */
		color: var(--color-gray-600);
		@apply text-sm;
	}

	.crumb {
		display: flex;
		align-items: center;
		gap: 0.5rem;
	}

	.crumb-text {
		@apply text-blue-500;
		cursor: pointer;
		&:hover {
			/* color: var(--color-gray-900); */
			@apply text-blue-700;
		}
		&.active {
			color: var(--color-gray-900);
			cursor: default;
		}
	}

	.separator {
		color: var(--color-gray-400);
	}

</style>